import type { AiModelEnum, QualityReportAiGravimetricComposition } from 'api';

import { AiAluSampleBreakdown } from '../AiAluSampleBreakdown/AiAluSampleBreakdown';

export const AiSampleBreakdown = ({
  composition,
  variant,
  totalWeight,
}: {
  composition: QualityReportAiGravimetricComposition;
  variant: AiModelEnum;
  totalWeight: number;
}) => (
  <>
    {variant === 'alu' && <AiAluSampleBreakdown composition={composition} totalWeight={totalWeight} />}
    {variant === 'briquette' && <AiAluSampleBreakdown composition={composition} totalWeight={totalWeight} />}
  </>
);
